import { render, staticRenderFns } from "./ModifyPayment.template.vue?vue&type=template&id=2a1a0c78&scoped=true&"
var script = {}
import style0 from "./ModifyPayment.template.vue?vue&type=style&index=0&id=2a1a0c78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a0c78",
  null
  
)

export default component.exports